import { Reveal } from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

const STEPS = [
  {
    n: "01",
    title: "Tell Us About Your Vehicle",
    text: "Send the year, make, model, and a brief description of its condition.",
  },
  {
    n: "02",
    title: "Get Your Quote",
    text: "We'll confirm your estimated price and availability.",
  },
  {
    n: "03",
    title: "We Come to You",
    text: "Your vehicle is detailed at your home, workplace, or agreed location.",
  },
];

const HowItWorks = () => (
  <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="how-it-works-section">
    <SectionHeading index="03" eyebrow="The Process" title="How It Works" />
    <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-3">
      {STEPS.map((step, i) => (
        <Reveal key={step.n} delay={i * 0.1} y={30}>
          <div className="flex h-full flex-col bg-obsidian p-8 sm:p-10" data-testid={`step-${step.n}`}>
            <span className="font-display text-6xl font-bold leading-none text-blue-600/40 sm:text-7xl" aria-hidden="true">
              {step.n}
            </span>
            <h3 className="mt-6 font-display text-2xl font-bold uppercase tracking-wide text-white">{step.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">{step.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default HowItWorks;
